<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal FileUploadAllowedTypesModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        File Upload - Allowed File Types
      </h2>
    </template>
    <template #modal-body>
      <p>Here is the overall list of the type of files a student can upload.</p>
      <table>
        <thead>
          <tr>
            <th style="width: 10%">
              Extension
            </th>
            <th style="width: 70%">
              Type
            </th>
            <th style="width: 20%">
              Category
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>.doc</td>
            <td>Microsoft Word</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.docx</td>
            <td>Microsoft Word (OpenXML)</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.pdf</td>
            <td>Adobe Portable Document Format (PDF)</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.ppt</td>
            <td>Microsoft PowerPoint</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.pptx</td>
            <td>Microsoft PowerPoint (OpenXML)</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.xls</td>
            <td>Microsoft Excel</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.xlsx</td>
            <td>Microsoft Excel (OpenXML)</td>
            <td>Documents</td>
          </tr>
          <tr>
            <td>.gif</td>
            <td>Graphics Interchange Format (GIF)</td>
            <td>Images</td>
          </tr>
          <tr>
            <td>.jpeg .jpg</td>
            <td>JPEG Images</td>
            <td>Images</td>
          </tr>
          <tr>
            <td>.png</td>
            <td>Portable Network Graphics</td>
            <td>Images</td>
          </tr>
          <tr>
            <td>.bmp</td>
            <td>Windows OS/2 Bitmap Graphics</td>
            <td>Images</td>
          </tr>
          <tr>
            <td>.webp</td>
            <td>WEBP Image</td>
            <td>Images</td>
          </tr>
          <tr>
            <td>.zip</td>
            <td>ZIP archive</td>
            <td>Zip (Compressed files)</td>
          </tr>
        </tbody>
      </table>
    </template>
  </rmp-base-modal>
</template>
<script>

import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
};
</script>
<style scoped lang="scss">
</style>
